<!-- <template>
  <div class="home">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
    <SubsTance />
    <TabnavigationBar />
    <FooterEnd />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import SubsTance from '@/components/SubsTance.vue'
import FooterEnd from '@/components/FooterEnd.vue'
import TabnavigationBar from '@/components/TabnavigationBar.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    SubsTance,
    FooterEnd,
    TabnavigationBar
  }
}
</script> -->
<template>
  <div class="hello">
    <header>
      <!-- 时间，登录 -->
      <div class="batten">
        <p>今天是: {{ dateFormat() }}</p>
        <div class="record" @click="push">
          <img src="../assets/image/login.png" alt="">
          <p>调解员登录</p>
        </div>
      </div>
      <!-- 标题 -->
      <div class="rubric">
        <p>高标准<img src="../assets/image/gh.png">一站式</p>
        <h1>{{ mediation }}</h1>
      </div>
      <!-- 导航栏 -->
      <div class="navigation">
        <div></div>
        <div class="navig"></div>
        <ul>
          <li @click="tabHome('0')" style="color: #fff;">
            <p :style="router1 == '0' ? lipcss : ''">首页</p>
          </li>
          <li @click="tabHome('1')" style="color: #fff;">
            <p :style="router1 == '1' ? lipcss : ''">判决案例</p>
          </li>
          <li @click="tabHome('2')" style="color: #fff;">
            <p :style="router1 == '2' ? lipcss : ''">调解指南</p>
          </li>
          <li @click="tabHome('3')" style="color: #fff;">
            <p :style="router1 == '3' ? lipcss : ''">调解员名录</p>
          </li>
          <li @click="tabHome('7')" style="color: #fff;">
            <p :style="router1 == '7' ? lipcss : ''">法院导航</p>
          </li>
        </ul>
        <div></div>
      </div>
      <div class="navigation1">
        <ul>
          <li @click="tabHome('0')" style="color: #fff;">
            <p :style="router1 == '0' ? lipcss : ''">首页</p>
          </li>
          <li @click="tabHome('1')" style="color: #fff;">
            <p :style="router1 == '1' ? lipcss : ''">判决案例</p>
          </li>
          <li @click="tabHome('2')" style="color: #fff;">
            <p :style="router1 == '2' ? lipcss : ''">调解指南</p>
          </li>
          <li @click="tabHome('3')" style="color: #fff;">
            <p :style="router1 == '3' ? lipcss : ''">调解员名录</p>
          </li>
          <li @click="tabHome('7')" style="color: #fff;">
            <p :style="router1 == '7' ? lipcss : ''">法院导航</p>
          </li>
        </ul>
      </div>
    </header>
    <!-- <router-view/> -->
    <TabnavigationBar @articlelist="articlelist" :router="router" v-show="router != 0" />
    <SubsTance @more="more" v-show="router == 0" />
    <FooterEnd :mediation="mediation" :address="address" :phone="phone" />
    <i class="el-icon-upload2 icon" @click="headpiece"></i>
  </div>
</template>

<script>
import FooterEnd from "@/components/FooterEnd.vue";
import TabnavigationBar from "@/components/TabnavigationBar.vue";
import SubsTance from "@/components/SubsTance.vue";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      mediation: '',//调解中心
      address: '',//地址
      phone: '',//监督电话
      activeName: "second",
      router: '0',
      router1: '0',
      lipcss: 'font-size: 20px;font-weight: bold;border-bottom:2.5px solid #fff;'
    };
  },
  components: {
    SubsTance,
    FooterEnd,
    TabnavigationBar
  },
  created() {
    if (!sessionStorage.getItem("resolution")) {
      sessionStorage.setItem("resolution", "7")
    }
  },
  mounted() {
    let resolution = ''
    if (JSON.parse(sessionStorage.getItem("resolution"))) {
      resolution = JSON.parse(sessionStorage.getItem("resolution"));
      if (resolution == 1) this.mediation = '常宁市数科纠纷调解中心';
      else if (resolution == 2) this.mediation = '襄阳襄州网络金融纠纷调解中心';
      else if (resolution == 3) this.mediation = '天门市正合多元调解中心';
      else if (resolution == 4) this.mediation = '山西九鼎金融纠纷调解中心';
      else if (resolution == 5) this.mediation = '荆门掇刀区商事仲裁调解服务中心';
      else if (resolution == 6) this.mediation = '汉中市洋县桓天纠纷调解中心';
      else if (resolution == 7) this.mediation = '枣强曙光商事调解中心';
    } else {
      setTimeout(() => {
        if (this.$route.name == 'cn') {
          resolution = 1;
          this.mediation = '常宁市数科纠纷调解中心';
          location.reload();
        }
        else if (this.$route.name == 'xy') {
          resolution = 2;
          this.mediation = '襄阳襄州网络金融纠纷调解中心';
          location.reload();
        }
        else if (this.$route.name == 'zh') {
          resolution = 3;
          this.mediation = '天门市正合多元调解中心';
          location.reload();
        }
        else if (this.$route.name == 'sx') {
          resolution = 4;
          this.mediation = '山西九鼎金融纠纷调解中心';
          location.reload();
        }
        else if (this.$route.name == 'jm') {
          resolution = 5;
          this.mediation = '荆门掇刀区商事仲裁调解服务中心';
          location.reload();
        }
        else if (this.$route.name == 'hz') {
          resolution = 6;
          this.mediation = '汉中市洋县桓天纠纷调解中心';
          location.reload();
        }
        else if (this.$route.name == 'zq') {
          resolution = 7;
          this.mediation = '枣强曙光商事调解中心';
          location.reload();
        }
        if (this.$route.name == 'TjymdNavigationbar') {
          if (this.$route.query.type) {
            resolution = this.$route.query.type
            this.tabHome('3')
            location.reload();
          }
        }
        sessionStorage.setItem("resolution", JSON.stringify(resolution))
      }, 100)
    }
    this.subst();
  },
  methods: {
    headpiece() {
      // 回到顶部
      window.scrollTo(0, 0);
    },
    push() {
      window.location = 'https://tiaojie.court.gov.cn/tjy/#/login'
    },
    subst() {
      // let data = sessionStorage.getItem("ssfwzn");
      // if (data) {
      //   this.router1 = JSON.parse(data)[0];
      //   this.router = JSON.parse(data)[0];
      // }
      let data = JSON.parse(sessionStorage.getItem("defaultactive"))
      if (data) {
        this.router1 = data;
        this.router = data;
      }
    },
    more(data) {
      window.scrollTo(0, 0)
      this.tabHome(data[0])
      sessionStorage.setItem("ssfwzn", JSON.stringify(data[1]));
    },
    articlelist(data) {
      this.router1 = data
    },
    tabHome(a) {
      this.router = a
      this.router1 = a
      sessionStorage.setItem("defaultactive", JSON.stringify(a));
    },
    subst1(a) {
      this.tabHome(a)
      if (this.$route.path == "/SubsTance") {
        this.router = '0'
        return;
      } else {
        this.$router.push("/SubsTance");
      }
    },
    handleClick(tab, event) {
    },
    // 获取当前时间
    dateFormat() {
      const dt = new Date();
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "")
      const d = (dt.getDate() + "")
      const weekDays = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      const dayOfWeek = dt.getDay();
      const currentWeekDay = weekDays[dayOfWeek];
      return `${y}年${m}月${d}日    ${currentWeekDay}`;
    },
  },
  watch: {
    immediate: true
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
header {
  width: 100%;
  height: 300px;
  background-image: url("../assets/image/headbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .batten {
    margin: 0 20px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      font-family: MediumFont;
      font-size: 18px;
    }

    .record {
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
        filter: grayscale(1);
      }

      // p{
      //   font-size: 18px;
      //   color: #3C3C3C;
      // }
    }

    .record:hover p {
      color: #BE1A0F;
    }

    .record:hover img {
      filter: grayscale(0);
    }
  }

  .rubric {
    width: 100%;
    height: 115px;
    text-align: center;
    margin: 30px 0;

    p {
      font-size: 36px;
      font-weight: lighter;
      color: #3c3c3c;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 50px;
        height: 50px;
        margin: 0 20px;
      }
    }

    h1 {
      color: #be1a0f;
      font-size: 42px;
    }
  }

  .navigation {
    width: 100%;
    height: 70px;
    position: relative;
    // overflow: hidden;
    top: 20px;

    div {
      background: #b7150a;
      width: calc((100% - 1196px) / 2 + 19px);
      // width: 280px;
      height: 60px;
      top: 0;
      position: absolute;
      z-index: 0;
    }

    div:nth-child(0) {
      left: 0;
    }

    div:nth-child(1) {
      right: 0;
    }

    .navig {
      width: 1196px;
      margin: 0 auto;
      position: absolute;
      height: 60px;
      top: 10px;
      left: calc((100% - 1196px) / 2);
      z-index: 1;
      box-shadow: 0px 2px 10px 0px rgba(31, 31, 31, 0.47);
      background: #be1a0f;
      transform: perspective(200px) rotateX(-5deg);
    }

    ul {
      width: 1196px;
      list-style: none;
      position: absolute;
      height: 60px;
      top: 10px;
      left: calc((100% - 1196px) / 2);
      z-index: 2;
      // padding: 0 112px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      li {
        width: 100%;
        font-size: 18px;
        color: #ffffff;
        transition: all 0.1s;
        text-align: center;
        line-height: 60px;
        letter-spacing: 3px;

        // border-bottom:0px solid #fff;
        p {
          height: 56px;
          display: inline-block;
        }
      }

      li:hover p {
        font-size: 20px;
        // transform: scale(1.1);
        font-weight: bold;
        border-bottom: 2.5px solid #fff;
      }
    }

    ul::after {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-color: transparent transparent transparent #9b0f05;
      border-style: solid;
      border-width: 10px 0 0 27px;
      top: -10px;
      right: -8px;
    }

    ul::before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-color: transparent #9b0f05 transparent transparent;
      border-style: solid;
      border-width: 10px 27px 0 0;
      top: -10px;
      left: -8px;
    }
  }
}

.navigation1 {
  display: none;
}

.icon {
  display: none;
}

@media screen and (max-width: 992px) {
  header {
    width: 100%;
    height: 170px;
    background-image: url("../assets/image/headbg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .batten {
      margin: 0 20px;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        font-family: MediumFont;
        font-size: 14px;
      }

      .record {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
          filter: grayscale(1);
        }

        // p{
        //   font-size: 18px;
        //   color: #3C3C3C;
        // }
      }

      .record:hover p {
        color: #be1a0f;
      }

      .record:hover img {
        filter: grayscale(0);
      }
    }

    .rubric {
      width: 100%;
      height: 50px;
      text-align: center;
      margin: 30px 0;

      p {
        font-size: 25px;
        font-weight: lighter;
        color: #3c3c3c;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 30px;
          height: 30px;
          margin: 0 10px;
        }
      }

      h1 {
        color: #be1a0f;
        font-size: 20px;
      }
    }

    .navigation {
      display: none;
    }

    .navigation1 {
      display: block;
      width: 100%;
      height: 40px;
      background: #be1a0f;

      ul {
        list-style: none;
        display: flex;
        justify-content: space-around;
        align-items: center;
        line-height: 40px;

        li {
          font-size: 15px;
        }
      }
    }
  }

  .icon {
    display: block;
    width: 40px;
    height: 40px;
    margin: 0 auto;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    font-size: 25px;
    position: fixed;
    bottom: 80px;
    right: 20px;
  }
}
</style>
